/**
 * Vue Router configuration
 * Defines application routes and navigation
 */

import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import { authGuard } from './authGuard'

/**
 * Application routes
 * Will be expanded as we build features
 */
const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/pages/LandingPage.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/LoginPage.vue'),
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/pages/RegisterPage.vue'),
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/pages/DashboardPage.vue'),
  },
  {
    path: '/workflows',
    name: 'workflows',
    component: () => import('@/pages/WorkflowsListPage.vue'),
  },
  {
    path: '/workflows/new',
    name: 'workflow-new',
    component: () => import('@/pages/WorkflowEditor.vue'),
  },
  {
    path: '/workflows/:id/edit',
    name: 'workflow-edit',
    component: () => import('@/pages/WorkflowEditor.vue'),
  },
  {
    path: '/connections',
    name: 'connections',
    component: () => import('@/pages/ConnectionsPage.vue'),
  },
  {
    path: '/api-keys',
    name: 'api-keys',
    component: () => import('@/pages/ApiKeysPage.vue'),
  },
  {
    path: '/api-endpoints',
    name: 'api-endpoints',
    component: () => import('@/pages/ApiEndpoints.vue'),
  },
  {
    path: '/api-docs',
    name: 'api-docs',
    component: () => import('@/pages/ApiDocsPage.vue'),
  },
  {
    path: '/projects',
    name: 'projects',
    component: () => import('@/pages/ProjectsPage.vue'),
  },
  {
    path: '/usage',
    name: 'usage',
    component: () => import('@/pages/UsagePage.vue'),
  },
  {
    path: '/status',
    name: 'status',
    component: () => import('@/pages/StatusPage.vue'),
  },
  {
    path: '/auth/action',
    name: 'auth-action',
    component: () => import('@/pages/AuthActionPage.vue'),
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('@/pages/ForgotPasswordPage.vue'),
  },
  {
    path: '/magic-link',
    name: 'magic-link',
    component: () => import('@/pages/MagicLinkLoginPage.vue'),
  },
  {
    path: '/auth/magic-link',
    name: 'magic-link-callback',
    component: () => import('@/pages/MagicLinkCallbackPage.vue'),
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/pages/SettingsPage.vue'),
  },
]

/**
 * Create router instance
 * Uses HTML5 history mode for clean URLs
 */
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

/**
 * Global navigation guard
 * Checks authentication before each route change
 */
router.beforeEach((to, from) => {
  return authGuard(to, from)
})

export default router